import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { get } from 'lodash';
import flattenKeyValuePairArrayToObject from '../../Shared/utils/flattenKeyValuePairArrayToObject';

export const GET_INSURANCE_TIER_INFO =
    gql`
        query getProviderInsuranceTiers($providerId: String, $carrierId: String!, $planId: String!, $locationId: String!){
            provider(id: $providerId){
                errorCode
                id
                selectedInsurance(carrierId: $carrierId, planId: $planId, locationId: $locationId) {
                    acceptsInsurance
                    properties {
                        key
                        value
                    }
                }
            }
        }
    `;

export const parseGql = ({ data }) => {
    if (data.loading) return { tiersLoading: true };
    // Because of the way apollo-client handles errors, we are including an
    // errorCode in the provider object rather than relying on data.error
    if (data.error || get(data, 'provider.errorCode')) return { hasErrors: true };
    return {
        selectedInsurance: {
            ...data.provider.selectedInsurance,
            properties: flattenKeyValuePairArrayToObject(data.provider.selectedInsurance.properties),
        },
    };
};

export const gqlOptions = ({
    carrierId,
    id,
    planId,
    providerId,
}) => {
    return {
        ssr: false,
        variables: {
            carrierId,
            locationId: id,
            planId,
            providerId,
        },
    };
};

const InsurancePickerKey = 'insurance-picker';

const mapStateToProps = state => {
    return {
        carrierId: state[InsurancePickerKey] ? state[InsurancePickerKey].carrier : -1,
        planId: state[InsurancePickerKey] ? state[InsurancePickerKey].plan : -1,
    };
};

export const withInsuranceTiers = component => {
    return connect(mapStateToProps, {})(graphql(GET_INSURANCE_TIER_INFO, {
        skip: ({
            providerId, carrierId, planId, id,
        }) => {
            return !providerId || !carrierId || !planId || !id;
        },
        options: gqlOptions,
        props: parseGql,
    })(component));
};
